<template>
  <ul class="sequence-list text-nowrap">
    <li v-for="sequence in sequences" :key="sequence.id">
      <template v-if="sequence.id === currentSequenceId">
        {{sequence | getSequenceShortName}}
      </template>

      <a
        v-if="sequence.id !== currentSequenceId"
        @click.prevent="selectSequence(sequence.id)"
        :href="sequence.id"
      >
        {{sequence | getSequenceShortName}}
      </a>
    </li>
  </ul>
</template>

<script>
import { getSequenceShortName } from '../../model/m3level.js';

export default {
  name: 'SequenceSelector',

  props: {
    sequences: {
      type: Array,
      required: true,
    },

    currentSequenceId: {
      type: Number,
      default: null,
    }
  },

  methods: {
    /**
     * @param {number} sequenceId
     */
    selectSequence(sequenceId) {
      this.$emit('sequence-selected', sequenceId);
    },
  },

  filters: {
    getSequenceShortName,
  },
}
</script>

<style scoped>
.sequence-list {
  list-style-type: none;
  padding: 0;
}
</style>
